<template>
  <Breadcrumb :items="breadcrumbs" />
  <CourseForm
    v-if="courseCtx.course"
    :course="courseCtx.course"
    :sections="['basic', 'images', 'settings']"
    redirect-to=""
    @saved="$emit('saved', $event)"
  />
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import CourseForm from './CourseForm.vue';

export default {
  name: 'CourseOverview',
  components: { Breadcrumb, CourseForm },
  inject: ['courseCtx'],
  emits: ['saved'],
  computed: {
    breadcrumbs() {
      return [
        ...this.courseCtx.breadcrumbBase,
        { name: 'نظرة عامة', path: `/courses/${this.courseCtx.courseId}` },
      ];
    },
  },
};
</script>
